<template>
  <o-confirmation-view
    image="images/bluebike-header.jpg"
    message="Je bestelling is met succes geregistreerd. Je ticket zal beschikbaar zijn in je ticketportefeuille van zodra de verwerking klaar is."
    nav-bar-title="Blue-bike"
  />
</template>

<script>
import OConfirmationView from '@/components/OConfirmationView.vue'
export default {
  name: 'BluebikeConfirmation',
  components: {
    OConfirmationView
  }
}
</script>
